<template>
  <modal
    v-if="name"
    :name="name"
    :adaptive="true"
    :classes="['v--modal', 'mastery-modal']"
    :click-to-close="false"
    :height="'auto'"
    :max-width="maxWidth"
    :reset="true"
    :scrollable="true"
    :width="'90%'"
    @before-open="$emit('before-open', $event)"
    @closed="$emit('close-fn')"
  >
    <component
      :is="type"
      :button-variant="buttonVariant"
      :header-image="headerImage"
      :header-image-size="headerImageSize"
      :primary-action-text="primaryActionText"
      :secondary-action-text="secondaryActionText"
      :title="title"
      @primary-action-clicked="$emit('primary-action-clicked')"
      @secondary-action-clicked="$emit('secondary-action-clicked')"
    >
      <button
        class="close"
        @click="handleForceClose"
      >
        <icon
          name="cross"
          variant="b3b3b3"
        />
      </button>
      <slot />
    </component>
  </modal>
</template>

<script>
import masteryModalBlue from '@components/ui/masteryModalBlue';
import masteryModalWhite from '@components/ui/masteryModalWhite';
import Icon from '@components/singletons/icon';

export default {
  components: { masteryModalBlue, masteryModalWhite, Icon },
  props: {
    beforeOpen: {
      type: Function,
      default: () => {},
    },
    buttonVariant: {
      type: String,
    },
    headerImage: {
      type: [Object, String],
    },
    headerImageSize:  {
      type: String,
      default: 'large',
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
    name: {
      type: String,
    },
    primaryActionText: {
      type: String,
    },
    secondaryActionText: {
      type: String,
    },
    title: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  emits: ['before-open', 'close-fn', 'primary-action-clicked', 'secondary-action-clicked', 'modal-force-closed'],
  methods: {
    handleForceClose() {
      this.$emit('modal-force-closed');
      this.$modal.hide(this.name);
    },
  },
};
</script>

<style lang="scss">
.v--modal-overlay[data-modal^="mastery"] {
  background-color: rgba(245, 245, 245, 0.64);

  .v--modal-background-click {
    @include breakpoint(small) {
      height: calc(100% - #{rem-calc(40)});
    }
  }
}

.mastery-modal {
  // for small screen sizes only, give the modal a margin so it has spacing on top and bottom if it fills the whole
  // screen and is scrollable, we don't do this on desktop because it is less likely and causes imperfect vertical centering,
  // the bad centering isn't a big deal on mobile because it makes the modal easier to reach with your thumb

  @include breakpoint(small) {
    margin: rem-calc(20) 0 !important;
  }

  > div {
    padding: rem-calc(32);
    text-align: center;

    @include breakpoint(small) {
      padding: rem-calc(16);
    }
  }

  .close {
    right: rem-calc(6);
    position: absolute;
    top: rem-calc(6);
    background: transparent;
    border: none;
    padding: 0;
    opacity: 0.4;

    @include breakpoint(small) {
      right: rem-calc(4);
    }

    img {
      height: rem-calc(18);
      width: rem-calc(18);

      @include breakpoint(small) {
        height: rem-calc(20);
        width: rem-calc(20);
      }
    }
  }
}

.v--modal-overlay[data-modal="catalog-add-modal"] {
  .v--modal-box {
    overflow: initial;
  }
}
</style>
